// Per-biome ambient bed — a sparse, quiet wind + low drone texture under everything, so each
// world has its own atmosphere even between gunshots. Pure params picker (headless-testable);
// AudioManager turns these into a continuous procedural WebAudio layer. No files, no copyright.

import { OscType } from './musicMood'

export interface AmbienceBed {
  /** low pad frequency (Hz) */
  droneFreq: number
  droneType: OscType
  /** drone level, quiet (~0..0.05) */
  droneGain: number
  /** filtered-noise wind level, quiet (~0..0.05) */
  windGain: number
  /** wind bandpass centre (Hz) — low = rumble, high = whistle */
  windCutoff: number
  /** wind bandpass resonance — higher = more tonal/eerie */
  windQ: number
}

// calm lunar plains — soft low pad, gentle mid wind
const MEADOW: AmbienceBed = { droneFreq: 55, droneType: 'sine', droneGain: 0.03, windGain: 0.022, windCutoff: 600, windQ: 0.7 }
// warm desert — fuller drone, higher airy wind, a touch louder
const DUNES: AmbienceBed = { droneFreq: 49, droneType: 'triangle', droneGain: 0.032, windGain: 0.03, windCutoff: 900, windQ: 1.1 }
// cold graveyard — hollow low drone, moaning resonant wind (eerie)
const GRAVEYARD: AmbienceBed = { droneFreq: 41, droneType: 'sine', droneGain: 0.036, windGain: 0.026, windCutoff: 320, windQ: 3.2 }
// tense rift — gritty drone, high unstable whistle
const RIFT: AmbienceBed = { droneFreq: 62, droneType: 'sawtooth', droneGain: 0.03, windGain: 0.034, windCutoff: 1250, windQ: 2.4 }

const BEDS: Record<string, AmbienceBed> = { meadow: MEADOW, dunes: DUNES, graveyard: GRAVEYARD, rift: RIFT }

/** The per-biome ambient bed for a map id; the calm meadow texture is the default. */
export function ambienceBed(mapId: string): AmbienceBed {
  return BEDS[mapId] ?? MEADOW
}
